import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { MatDialog } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.checkToken().pipe(
      map((res) => {
        if (res.success) {
          return true;
        } else {
          this.authService.logout();
          this.router.navigate(['auth/login']);
          return false;
        }
      }),
      catchError((err) => {
        this.authService.logout();
        this.router.navigate(['auth/login']);
        return of(false);
      })
    );
  }
}
